// Penjelasan ramah untuk tipe feses (Skala Bristol) — dipakai bersama
// di Dashboard, GILog, Progress. Konsisten dengan koreksi InfoHub:
// Tipe 1-2 = sembelit, 3-4-5 = normal (4 ideal), 6-7 = diare.

export function getStoolInfo(type, isID = true) {
  const t = Number(type);
  const map = {
    1: { tone: 'danger', id: 'Perlu perhatian (sembelit)', en: 'Needs attention — constipation' },
    2: { tone: 'warn',   id: 'Cenderung sembelit',         en: 'Tends toward constipation' },
    3: { tone: 'good',   id: 'Normal',                     en: 'Normal' },
    4: { tone: 'good',   id: 'Normal (Ideal)',             en: 'Normal — ideal' },
    5: { tone: 'warn',   id: 'Cenderung kurang serat',     en: 'Tends toward low fiber' },
    6: { tone: 'warn',   id: 'Cenderung diare',            en: 'Tends toward diarrhea' },
    7: { tone: 'danger', id: 'Perlu perhatian (diare)',    en: 'Needs attention — diarrhea' },
  };
  const info = map[t];
  if (!info) return { tone: 'neutral', label: '-' };
  return { tone: info.tone, label: isID ? info.id : info.en };
}